module.exports = __webpack_public_path__ + "img/logo2.f386c3b7.png";